// "2025 - winter" (what the match form shows), or the season's name when it has one
export function seasonLabel(season) {
    if (!season) return ''
    const base = `${season.year} - ${season.type}`
    return season.name ? `${season.name} (${base})` : base
}

// newest season first
export function sortSeasons(seasons) {
    return (seasons || []).slice().sort((a, b) => new Date(b.startDate) - new Date(a.startDate))
}
